export const isVitestEnv = import.meta.env.VITEST

export function ifVitestEnv (callback: () => void) {
  if (isVitestEnv) callback()
}

export function unlessVitestEnv (callback: () => void) {
  if (!isVitestEnv) callback()
}